/** Formats English months names with the correct Reuters style abbreviations:
 * - Mar. with March
 * - Apr. with April
 * - May. with May
 * - Jun. with June
 * - Jul. with July
 * - Sep. with Sept.
 */
export const monthFormatter = (text: string): string => {
  return text.replace(/(Mar\.|Apr\.|May\.|Jun\.|Jul\.|Sep\.)/g, (match) => {
    switch (match) {
      case 'Mar.':
        return 'March';
      case 'Apr.':
        return 'April';
      case 'May.':
        return 'May';
      case 'Jun.':
        return 'June';
      case 'Jul.':
        return 'July';
      case 'Sep.':
        return 'Sept.';
      default:
        return match;
    }
  });
};

/**  Rounds a value to the specified number of decimal points */
export const roundValue = (value: number, decimalPlaces: number) => {
  return value.toFixed(decimalPlaces);
};
